import { tryCatchHelper } from '../../../../helpers';
import { saveNotasEvaluativasService } from './NotasEvaluativasService';
import { allEstudiantesNotasEvaluativasAction } from '../../estudiantes/EstudiantesAction';

export const saveNotasEvaluativasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveNotasEvaluativasService(id, data);
    notify(res.data.message);
    await allEstudiantesNotasEvaluativasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

// export const setActivoNotasEvaluativasAction = async (dispatch, data) => {
//   dispatch({ type: ACTIVO_NOTAS_EVALUATIVAS, payload: data });
// };

// export const oneNotasEvaluativasAction = async (dispatch, idEntidad, id) => {
//   try {
//     const res = await oneNotasEvaluativasService(idEntidad, id);
//     await setActivoNotasEvaluativasAction(dispatch, res.data);
//     return res.data;
//   } catch (e) {
//     tryCatchHelper(e);
//     return false;
//   }
// };

// export const deleteNotasEvaluativasAction = async (
//   { dispatch, notify },
//   idEntidad,
//   id,
//   params,
// ) => {
//   try {
//     const res = await deleteNotasEvaluativasService(idEntidad, id);
//     await setActivoNotasEvaluativasAction(dispatch, null);
//     notify(res.data.message);
//     await allNotasEvaluativasAction(dispatch, idEntidad, params);
//     return res.data;
//   } catch (e) {
//     tryCatchHelper(e);
//     return false;
//   }
// };
